import * as angular from 'angular';

import { UserVenueHistoryComponent } from './user-venue-history.component';

export const HistoryModule = angular.module('HistoryModule', [])
  .component('userVenueHistory', UserVenueHistoryComponent)
  .name;
